const $inject = [
  "$scope",
  "$rootScope",
  "$state",
  "$uibModal",
  "CommonData",
  "DefaultDateService",
  "FormatService",
  "ReferralService",
  "UndefinedDataService",
  "ValidateService",
];

class FaxController {
  /**
   * @param $scope
   * @param $rootScope
   * @param $state
   * @param $uibModal
   * @param {object} CommonData
   * @param {DefaultDateService} DefaultDateService
   * @param {FormatService} FormatService
   * @param {ReferralService} ReferralService
   * @param {UndefinedDataService} UndefinedDataService
   * @param {ValidateService} ValidateService
   */
  constructor(
    $scope,
    $rootScope,
    $state,
    $uibModal,
    CommonData,
    DefaultDateService,
    FormatService,
    ReferralService,
    UndefinedDataService,
    ValidateService
  ) {
    //noinspection JSUnresolvedVariable
    let id = Number($state.params.id);
    this.$scope = $scope;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.format = FormatService;
    this.ReferralService = ReferralService;
    this.UndefinedDataService = UndefinedDataService;
    this.validate = ValidateService;
    this.is_idle = true;
    this.submitted = false;

    $scope.show_toast = function ($message, $class) {
      $rootScope.$emit("display-toast", $message, $class);
    };

    $scope.hide_toast = function () {
      $rootScope.$emit("remove-toast");
    };

    $scope.states = CommonData.STATES;
    $scope.titles = CommonData.TITLES;
    $scope.titles_with_blank = CommonData.TITLES.slice();
    $scope.titles_with_blank.push("");

    this.options = {
      debounce: {
        default: 500,
        blur: 0,
      },
    };

    this.date_picker = {
      opened: false,
    };

    $scope.dateOfBirthDateOptions = {
      minDate: DefaultDateService.earliest_date_of_birth(),
      maxDate: new Date(),
      initDate: DefaultDateService.default_date_of_birth(),
    };

    if ($rootScope.hmrs) {
      $scope.hmr = null;
      let self = this;
      //noinspection JSUnusedLocalSymbols
      const referral_listener = function (newCollection, oldCollection, scope) {
        if (newCollection !== oldCollection) {
          self.auto_save();
        }
      };
      for (let hmr of $rootScope.hmrs) {
        if (hmr.id === id) {
          $scope.hmr = hmr;
          $scope.$watchCollection("hmr.referral", referral_listener);
          $scope.$watchCollection("hmr.clinic.id", referral_listener);
          $scope.$watchCollection("hmr.gp.id", referral_listener);

          if (hmr.referral) {
            if (hmr.referral.patientPhone) {
              hmr.referral.patientPhone = this.format.phone(hmr.referral.patientPhone);
            }

            if (hmr.referral.patientMedicare) {
              hmr.referral.patientMedicare = this.format.medicare(hmr.referral.patientMedicare);
            }
          }

          this.clinic_gps();
          break;
        }
      }
      if (id && $scope.hmr === null) {
        //noinspection JSCheckFunctionSignatures
        this.$state.go("admin.referrals.referral.fax.index");
      }
    }
  }

  //noinspection JSUnusedLocalSymbols
  openDateOfBirthDatepicker($event) {
    this.date_picker.opened = true;
  }

  openSupportingFilesModal() {
    this.$scope.file_download_route = "admin.referrals.referral.file-download";

    this.$uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: 'hmrSupportingFilesModal.html',
      controller: 'HmrSupportingFilesModalController',
      controllerAs: 'HmrSupportingFilesCtrl',
      resolve: {
        hmr: this.$scope.hmr,
      },
      scope: this.$scope,
    });
  }

  auto_save() {
    this.pending = this.$scope.hmr;
    if (this.is_idle) {
      this.save(false);
    }
  }

  save_final() {
    this.submitted = true;
    if (this.$scope.hmrForm.$invalid) {
      this.focus_first_invalid_field();
      let error_message = this.get_angular_error_message();
      this.$scope.show_toast(error_message, "alert-danger");
    }
    else {
      this.is_idle = false;
      this.pending = this.$scope.hmr;
      this.$scope.hide_toast();
      this.save(true);
    }
  }

  /**
   * @param {boolean} final
   */
  save(final) {
    if (this.$state.current.name !== "admin.referrals.referral.fax.edit") {
      return;
    }

    let hmr = angular.copy(this.pending);
    this.pending = null;
    let self = this;

    if (hmr.referral) {
      hmr.referral = this.UndefinedDataService.replace(hmr.referral);

      if (hmr.referral.patientPhone) {
        hmr.referral.patientPhone = hmr.referral.patientPhone.replace(/\D+/g, "");
      }

      if (hmr.referral.patientPhoneBusiness) {
        hmr.referral.patientPhoneBusiness = hmr.referral.patientPhoneBusiness.replace(/\D+/g, "");
      }

      if (hmr.referral.patientMedicare) {
        hmr.referral.patientMedicare = hmr.referral.patientMedicare.replace(/\D+/g, "");
      }
    }

    let handleSuccess = function (response) {
      self.is_idle = true;
      self.$scope.hide_toast();

      if (!response.data.success) {
        handleError(response);
      }
      else {
        if (self.pending) {
          self.save(final);
        }
        else {
          if (final) {
            let errors = self.get_symfony_errors("hmr", response.data.data.errors.form);
            if (response.data.data.hmr.has_complete_patient_details || response.data.data.override_errors || errors.length === 0) {
              //noinspection JSCheckFunctionSignatures
              self.$state.go("admin.referrals.referral.fax", {}, {reload: true});
            }
            else {
              self.focus_first_invalid_field();

              let error_message = self.get_symfony_error_message(errors);

              self.$scope.show_toast(error_message, "alert-danger");
            }
          }
        }
      }

      return response.data.data;
    };

    let handleError = function (response) {
      self.is_idle = true;

      let error_message;

      if (!response.data || !response.data.message) {
        error_message = "An unexpected server error occurred.";
      }
      else {
        if (!response.data.data || !response.data.data.errors || !response.data.data.errors.length) {
          error_message = response.data.message;
        }
        else {
          error_message = []
            .concat(response.data.message)
            .concat(response.data.data.errors)
          ;
        }
      }

      self.$scope.show_toast(error_message, "alert-danger");
    };

    this.ReferralService.save_fax(hmr, final, handleSuccess, handleError);
  }

  focus_first_invalid_field() {
    // TODO See https://stackoverflow.com/questions/20365121/set-focus-on-first-invalid-input-in-angularjs-form for more ideas
    angular.element("input.ng-invalid").first().focus();
  }

  get_symfony_errors(parent_key, data, errors = []) {
    for (let field in data.children) {
      if (data.children.hasOwnProperty(field)) {
        if (data.children[field].children) {
          this.get_symfony_errors(parent_key + "." + field, data.children[field], errors);
        }
        else if (data.children[field].errors) {
          errors[parent_key + "." + field] = data.children[field].errors;
        }
      }
    }
    return errors;
  }

  get_symfony_error_message(errors) {
    let error_message = [];
    for (let key in errors) {
      if (errors.hasOwnProperty(key)) {
        let label = angular.element("[ng-model='" + key + "']")[0].labels[0];
        let text_key = this.get_label_text(label);
        for (let error of errors[key]) {
          error_message.push(text_key + error);
        }
      }
    }
    error_message.unshift("Please correct the following error" + (error_message.length === 1? "": "s") + " before submitting again.");
    return error_message;
  }

  get_angular_error_message() {
    let error_message = [];
    for (let error_type in this.$scope.hmrForm.$error) {
      if (this.$scope.hmrForm.$error.hasOwnProperty(error_type)) {
        for (let field of this.$scope.hmrForm.$error[error_type]) {
          let element = angular.element("[name='" + field.$name + "']")[0];
          let label = element.labels[0];
          let text_key = this.get_label_text(label);
          if (element.title) {
            error_message.push(text_key + element.title);
          }
          else {
            error_message.push(text_key + error_type);
          }
        }
      }
    }
    error_message.unshift("Please correct the following error" + (error_message.length === 1? "": "s") + " before submitting again.");
    return error_message;
  }

  get_label_text(label) {
    let text_key = "";
    for (let label_node of label.childNodes) {
      if (label_node.nodeType === Node.TEXT_NODE) {
        text_key += label_node.textContent;
      }
    }
    return text_key.replace(/:?\s*$/, ": ");
  }

  clinic_selected() {
    if (!this.$scope.hmr.clinic.gps.map(gp => gp.id).includes(this.$scope.hmr.gp? this.$scope.hmr.gp.id: null)) {
      this.$scope.hmr.gp = null;
    }
    this.clinic_gps();
  }

  clinic_gps() {
    let gps = this.$scope.hmr.clinic.gps.filter(gp => !gp.is_placeholder);
    gps.unshift({id: null, is_placeholder: true, full_name: 'New GP'});
    this.$scope.gps = gps;
    //return gps;
  }
}

FaxController.$inject = $inject;
export default FaxController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/fax.controller.js
 **/